import React from "react";
import styles from "./styles";
import { withStyles, Divider, Grid, withTheme } from "@material-ui/core";
import { postData } from "../../../../../../api/componentAPIs";
import { withSnackbar } from "notistack";
import { compose } from "recompose";
import Events from "../../../../../../utilities/EventEmitter";
import drawConstant from "../../../common/DrawTools/DrawConstant";
import { withAppConfig } from "../../../../../../appConfigContext";
import ActionButton from "./ActionButton";
import Fields from "./Fields";
class OnBoardTerminalForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: null,
      errorInfo: {},
      inputValue: null,
      updateInProgress: false,
      terminalInfo: this.getDefaultTerminalInfo(),
    };
  }
  componentDidMount() {
    const { ROUTE_MAPPING_EVENTS } = drawConstant;
    Events.on(ROUTE_MAPPING_EVENTS.DRAWING_UPDATED, this.handleDrawingUpdate);
    Events.on(ROUTE_MAPPING_EVENTS.DRAWING_DELETED, this.handleDrawingDelete);
  }
  componentWillUnmount() {
    const { ROUTE_MAPPING_EVENTS } = drawConstant;
    Events.off(ROUTE_MAPPING_EVENTS.DRAWING_UPDATED, this.handleDrawingUpdate);
    Events.off(ROUTE_MAPPING_EVENTS.DRAWING_DELETED, this.handleDrawingDelete);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.terminalPosition &&
      !Object.is(this.props.terminalPosition, prevProps.terminalPosition) &&
      this.props.terminalPosition?.latitude !==
        this.state.terminalInfo?.latitude &&
      this.props.terminalPosition?.longitude !==
        this.state.terminalInfo?.longitude
    ) {
      //if position of marker changes in a map this will update it in the geocoder
      this.setState({
        inputValue: `${this.props.terminalPosition?.latitude},${this.props.terminalPosition?.longitude}`,
      });
    }
  }

  getDefaultTerminalInfo() {
    const { terminalInfo } = this.props;
    if (terminalInfo) {
      this.setState({
        inputValue: `${terminalInfo.latitude},${terminalInfo.longitude}`,
      });
      this.selectGeoFenceOnMap(terminalInfo?.terminalId);
    }
    return {
      terminalCode: terminalInfo?.terminalCode || "",
      terminalName: terminalInfo?.terminalName || "",
      longitude: terminalInfo?.longitude || "",
      latitude: terminalInfo?.latitude || "",
      utcToLocalOffset: terminalInfo?.utcToLocalOffset || "",
      region: terminalInfo?.regionName || "",
      division: terminalInfo?.divisionName || "",
      city: terminalInfo?.city || "",
      state: terminalInfo?.state || "",
      zip: terminalInfo?.zip || "",
      isEnabled: terminalInfo ? terminalInfo.isEnabled : true,
      geoFence: terminalInfo?.geoFence || null,
      address: terminalInfo?.address || "",
      sourceTerminalCode:
        this.props.configJSON.terminalOnboarding?.sourceTerminalCode || "",
      country: terminalInfo?.country || "",
      terminalId: terminalInfo?.terminalId || "new",
    };
  }
  selectGeoFenceOnMap = (terminalId) => {
    //need some delay to select drawing so added this code 
    // it will take some time to load and draw already exist geofencing after that only we can create.
    //we can remove this settime out if we find better solution 
    setTimeout(() => {
      Events.emit(
        drawConstant.ROUTE_MAPPING_EVENTS.DRAWING_SELECTED_ON_SIDE_PANEL,
        [terminalId],
        true
      );
    }, 0);
  };

  handleDrawingUpdate = (feature) => {
    this.setState({
      terminalInfo: {
        ...this.state.terminalInfo,
        ["geoFence"]: JSON.stringify(feature.geometry.coordinates[0]),
      },
    });
    if (this.props.terminalInfo?.terminalId !== feature.id) {
      this.props.terminalGeoFencingChange(
        JSON.stringify(feature.geometry.coordinates[0])
      );
    }
    this.selectGeoFenceOnMap(this.state.terminalInfo?.terminalId);
  };

  handleDrawingDelete = (feature) => {
    this.setState({
      terminalInfo: {
        ...this.state.terminalInfo,
        ["geoFence"]: null,
      },
    });
    this.props.terminalGeoFencingChange(null);
  };

  // Update terminalInfo based on inputs
  handleChange = (name) => (value) => {
    if (name === "division") {
      value = value?.value || null;
    }
    if (name === "region") {
      value = value?.value || null;
    }
    if (name === "utcToLocalOffset") {
      value = value?.value || null;
    }

    this.setState((state) => ({
      terminalInfo: {
        ...state.terminalInfo,
        [name]: value,
      },
      errorInfo: {
        ...state.errorInfo,
        [name]: this.getFieldError(name, value),
      },
      errorMessage: null,
    }));
  };
  isValidLatitude = (lat) => {
    if (lat) {
      return isFinite(lat) && Math.abs(lat) <= 90 ? null : "* Invalid value";
    }
    return "* Required";
  };

  isValidLongitude = (lng) => {
    if (lng) {
      return isFinite(lng) && Math.abs(lng) <= 180 ? null : "* Invalid value";
    }
    return "* Required";
  };

  // Checks for errors for each field
  getFieldError = (field, value) => {
    switch (field) {
      case "terminalCode":
        return value?.trim() ? null : "* Required";
      case "terminalName":
        return value?.trim() ? null : "* Required";
      case "division":
        return value?.trim() ? null : "* Required";
      case "region":
        return value?.trim() ? null : "* Required";
      case "address":
        return value?.trim() ? null : "* Required";
      case "zip":
        return value?.trim() ? null : "* Required";
      case "city":
        return value?.trim() ? null : "* Required";
      case "country":
        return value?.trim() ? null : "* Required";
      case "state":
        return value?.trim() ? null : "* Required";
      case "latitude":
        return this.isValidLatitude(value);
      case "longitude":
        return this.isValidLongitude(value);
      case "utcToLocalOffset":
        return value ? null : "* Required";
      default:
        return null;
    }
  };

  getLocationDetails = ([longitude, latitude], zip, address, Address) => {
    if (longitude && latitude && address) {
      if (
        latitude !== this.state.terminalInfo?.latitude &&
        longitude !== this.state.terminalInfo?.longitude
      ) {
        this.setState({
          terminalInfo: {
            ...this.state.terminalInfo,
            ["latitude"]: latitude,
            ["longitude"]: longitude,
            ["zip"]: zip,
            ["city"]: Address.City,
            ["country"]: Address.Country,
            ["state"]: Address.State,
            ["address"]: address,
          },
          errorInfo: {
            ...this.state.errorInfo,
            ["latitude"]: this.getFieldError("latitude", latitude),
            ["longitude"]: this.getFieldError("longitude", longitude),
            ["zip"]: this.getFieldError("zip", zip),
            ["city"]: this.getFieldError("city", Address.City),
            ["country"]: this.getFieldError("country", Address.Country),
            ["state"]: this.getFieldError("state", Address.State),
          },
        });
        this.handleChange("address")(address);
      }
      if (this.state.terminalInfo?.address !== address) {
        this.props.terminalPositionChange({
          latitude: latitude,
          longitude: longitude,
        });
      }
    } else {
      if (this.props.terminalInfo) {
        this.setState({
          inputValue: `${this.props.terminalInfo.latitude},${this.props.terminalInfo.longitude}`,
        });
      }
      this.props.terminalPositionChange(null);
    }
  };

  // Set Error messages for each field
  getErrorInfo = () => {
    let errorInfo = {};
    Object.keys(this.state.terminalInfo).forEach((fieldName) => {
      errorInfo[fieldName] = this.getFieldError(
        fieldName,
        this.state.terminalInfo[fieldName]
      );
    });
    this.setState({
      errorInfo,
    });
    return errorInfo;
  };

  updateTerminalInfo = () => {
    const errorInfo = this.getErrorInfo();
    const errorData = Object.values(errorInfo).filter((value) => value).length;
    if (!errorData) {
      const data = this.state.terminalInfo;
      delete data["terminalId"];
      this.setState({ updateInProgress: true });
      postData("SaveTerminal", data).then(
        (response) => {
          if (response && response.status >= 200 && response.status < 400) {
            this.setState({ updateInProgress: false });
            this.props.getTerminalData();
            this.props.onClose();
            this.props.enqueueSnackbar(
              `Terminal ${
                this.props.terminalInfo ? "updated" : "onboard"
              } successfully`,
              {
                variant: "success",
              }
            );
          } else {
            this.handleError(
              this.props.terminalInfo ? "updating" : "onboarding"
            );
          }
        },
        (error) => {
          this.setState({ updateInProgress: false });
          this.handleError(this.props.terminalInfo ? "updating" : "onboarding");
        }
      );
    }
  };

  handleError = (Type) => {
    this.props.enqueueSnackbar(
      `Error while ${Type} terminal ${this.state.terminalInfo.terminalName}`,
      { variant: "error" }
    );
  };

  toggleAutoZooms = (isEnabled) => {
    this.handleChange("isEnabled")(!isEnabled);
  };

  getAddress = () => {
    if (this.props.terminalInfo) {
      this.setState({
        inputValue: `${this.props.terminalInfo.latitude},${this.props.terminalInfo.longitude}`,
      });
      return `${this.props.terminalInfo.latitude},${this.props.terminalInfo.longitude}`;
    }
    return "";
  };

  render() {
    const { classes, theme, terminalList } = this.props;
    const {
      terminalInfo,
      errorInfo,
      inputValue,
      updateInProgress,
      errorMessage,
    } = this.state;

    const buttonText = this.props.terminalInfo
      ? "Update Terminal"
      : "Create Terminal";
    return (
      <div className={`${classes.container} OnBoardTerminalForm`}>
        <div>
          <Grid item xs={12} className={classes.head}>
            {this.props.terminalInfo
              ? "Update Terminal Details"
              : "Add Terminal Details"}
          </Grid>
          <Divider className={classes.divider} />
        </div>
        <div className={`${classes.content} customScroll`}>
          <Fields
            terminalInfo={terminalInfo}
            errorInfo={errorInfo}
            inputValue={inputValue}
            classes={classes}
            theme={theme}
            terminalList={terminalList}
            toggleAutoZooms={this.toggleAutoZooms}
            handleChange={this.handleChange}
            propsTerminalInfo={this.props.terminalInfo}
            getLocationDetails={this.getLocationDetails}
            getAddress={this.getAddress}
            errorMessage={errorMessage}
          />
          <ActionButton
            classes={classes}
            onClose={this.props.onClose}
            updateTerminalInfo={this.updateTerminalInfo}
            updateInProgress={updateInProgress}
            buttonText={buttonText}
          />
        </div>
      </div>
    );
  }
}

export default compose(
  withStyles(styles),
  withTheme(),
  withSnackbar,
  withAppConfig
)(OnBoardTerminalForm);
